var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4129_3028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.293 1.293C6.10551 1.10545 5.85119 1.00006 5.586 1H2C1.73478 1 1.48043 1.10536 1.29289 1.29289C1.10536 1.48043 1 1.73478 1 2V5.586C1.00006 5.85119 1.10545 6.10551 1.293 6.293L5.645 10.645C5.87226 10.8708 6.17962 10.9976 6.5 10.9976C6.82038 10.9976 7.12774 10.8708 7.355 10.645L10.645 7.355C10.8708 7.12774 10.9976 6.82038 10.9976 6.5C10.9976 6.17962 10.8708 5.87226 10.645 5.645L6.293 1.293Z",
    stroke: "#6A7181",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 4C3.88807 4 4 3.88807 4 3.75C4 3.61193 3.88807 3.5 3.75 3.5C3.61193 3.5 3.5 3.61193 3.5 3.75C3.5 3.88807 3.61193 4 3.75 4Z",
    fill: "#6A7181",
    stroke: "#6A7181",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4129_3028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.3186262f4c8993348072490cc6c556a1.svg";
export { ForwardRef as ReactComponent };